import axios from 'axios'
import config from "../config/constants";
import { toastr } from 'react-redux-toastr';

export const LOAD_CREDENTIALS = "LOAD_CREDENTIALS";
export const CREATE_CREDENTIALS = "CREATE_CREDENTIALS";
export const UPDATE_CREDENTIALS = "UPDATE_CREDENTIALS";
export const ERROR = "ERROR";
export const LOAD_CLOUD_STORAGE = "LOAD_CLOUD_STORAGE";
export const LOAD_LOCAL_STORAGE = "LOAD_LOCAL_STORAGE";

export const loadCredentials = (props, scope) => {
    return (dispatch, getState) => {
        axios.get(config.PROJECT_DASHBOARD_API_URL + 'aiservice/config/credentials').then(({ data }) => {
            dispatch({
                type: LOAD_CREDENTIALS,
                payload: data
            });
        });
    }
}

export const createCredentials = (props, scope) => {
    return (dispatch, getState) => {
        axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/config/credentials', props).then(({ data }) => {
            toastr.success('Successfully updated the credentials');
        });
    };
}

export const loadCloudStorage = (props, scope) => {
    return (dispatch, getState) => {
        axios.get(config.PROJECT_DASHBOARD_API_URL + 'aiservice/config/cloud_storage').then(({ data }) => {
            dispatch({
                type: LOAD_CLOUD_STORAGE,
                payload: data
            });
        });
    }
}

export const createCloudStorage = (props, scope) => {
    return (dispatch, getState) => {
        axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/config/cloud_storage', props).then(({ data }) => {
            toastr.success('Successfully updated the cloud storage settings');
        });
    };
}

export const loadLocalStorage = (props, scope) => {
    return (dispatch, getState) => {
        axios.get(config.PROJECT_DASHBOARD_API_URL + 'aiservice/config/local_storage').then(({ data }) => {
            dispatch({
                type: LOAD_LOCAL_STORAGE,
                payload: data
            });
        });
    }
}

export const createLocalStorage = (props, scope) => {
    return (dispatch, getState) => {
        axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/config/local_storage', props).then(({ data }) => {
            toastr.success('Successfully updated the local storage settings');
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/settings.js